import { useEffect, useState } from "react";
import { List } from "antd";
import { OrderPaymentItem } from "./order-paymentItem";

type Props = {
  delivery?: any;
  items?: any;
  invoice?: any;
  updateOrderData?: () => void;
  creditMemos?: any;
  balance?: number;
  billingAddress?: any;
  shipments?: any;
  orderId?: number;
  orderStatus?: string | null;
  additionalPayment?: number | null;
};

export const OrderPayment = ({
  delivery,
  items,
  invoice,
  updateOrderData,
  creditMemos,
  balance,
  billingAddress,
  shipments,
  orderId,
  orderStatus,
  additionalPayment,
}: Props) => {
  const STATUSORDER = ["pending", "review", "verified", "invoiced", "canceled"];

  return (
    <List
      className="summary-list"
      itemLayout="vertical"
      size="large"
      dataSource={items}
      renderItem={(item: any, index: number) => (
        <div id={`payment-panel-${item.paymentId}`}>
        <OrderPaymentItem
          key={item.paymentId}
          item={item}
          invoice={invoice}
          delivery={delivery}
          balance={balance}
          billingAddress={billingAddress}
          statusOrder={STATUSORDER}
          updateOrderData={updateOrderData}
          creditMemos={creditMemos}
          shipments={shipments}
          // Manual extra charges (vendor_additional_payment) is a per-order
          // concept; show the editor only once on the first payment card.
          showManualExtraCharges={index === 0}
          orderId={orderId}
          orderStatus={orderStatus}
          additionalPayment={additionalPayment}
        />
        </div>
      )}
    />
  );
};
